import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';

import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { Breadcrumb, Button, Card, Col, Container, Form, Row, Table } from 'react-bootstrap';
import Flatpickr from 'react-flatpickr';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import FormProvider from '../../../FunctionalComponent/FormElement/FormProvider';
import Dropzone from 'react-dropzone';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useGetActiveColorMutation } from '../../../Redux/ColorSlice';
import { useGetActivesizeMutation } from '../../../Redux/SizeSlice';
import {
  getProductInfos,
  setProductCurrentStep,
  setProductInfo,
  useCreateProductStepTwoMutation,
  useSpecificationProductMutation,
} from '../../../Redux/ProductSlice';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useUplaodFileMutation } from '../../../Redux/file/fileApi';
import RHSelectField from '../../../FunctionalComponent/FormElement/RHSelectField';
import {
  specificationApi,
  useGetSpecificationMutation,
  useGetSpecificationsTypeQuery,
} from '../../../Redux/specification/specificationApi';
import DeleteModal from '../../../Common/modals/DeleteModal';

const validateWith = {
  shouldDirty: true,
  shouldTouch: true,
  shouldValidate: true,
};

const StepSpecification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getProducInfo = useSelector(getProductInfos);

  const productId = getProducInfo?.productId;

  const [createProductFn, { data, error, isLoading }] = useCreateProductStepTwoMutation();
  const { data: listData, isLoading: listLoading } = useGetSpecificationsTypeQuery();

  const [isExit, setIsExit] = useState(false);

  const [globalLoading, setGlobalLoading] = useState(false);

  // useEffect(() => {
  //   getActiveColorFn();
  //   getActiveSizeFn();
  // }, []);

  const defaultValues = {
    productId: productId,
    testNr: [],
    testArrays: [],
  };

  const methods = useForm({
    // resolver: yupResolver(stepOneSchema),
    defaultValues,
    mode: 'all',
  });

  const {
    reset,
    register,
    setError,
    setValue,
    handleSubmit,
    watch,
    getValues,
    control,
    formState: { errors },
  } = methods;

  const {
    fields: testNrFields,
    append: addtestNr,
    remove: removetestNr,
  } = useFieldArray({
    control,
    name: 'testNr',
  });

  const {
    fields: testArraysFields,
    append: addtestArrays,
    remove: removetestArrays,
  } = useFieldArray({
    control,
    name: 'testArrays',
  });

  const [sftype, setSftype] = useState({});

  const sftypeValue = async (e, index) => {
    setValue(`testNr.${index}.item`, e.target.value);
    try {
      const specificationId = listData?.response?.find((it) => it.name == e.target.value)?.id;

      const spData = await dispatch(
        specificationApi.endpoints.GetSpecification.initiate(specificationId),
      ).unwrap();
      setSftype((prev) => ({
        ...prev,
        [e.target.value]: spData?.response?.value,
      }));
    } catch (error) { }
  };

  useEffect(() => {
    if (productId && listData?.response?.length > 0) {
      setGlobalLoading(true);
      const specificationData = getProducInfo?.ProductSpecification?.specifications || {};

      const sDatassss = Object.keys(specificationData)?.map((item, index) => {
        return { item, value: specificationData[item] };
      });

      Object.keys(specificationData)?.map(async (item, index) => {
        // setValue(`testNr.${index}.item`, item);
        try {
          const spData = await dispatch(
            specificationApi.endpoints.GetSpecification.initiate(
              listData?.response?.find((it) => it.name == item)?.id,
            ),
          ).unwrap();
          await setSftype((prev) => ({ ...prev, [item]: spData?.response?.value }));
        } catch (error) { }

        return { item, value: specificationData[item] };
      });

      setValue('testNr', sDatassss);
      setGlobalLoading(false);
    }
  }, [productId, listData?.response]);

  const yy = watch();

  const [fn, { isSuccess }] = useSpecificationProductMutation();

  const params = useParams();

  const onSubmit = () => {
    // const data = getValues('testNr');

    const specificationData = getValues('testNr') || [];

    const formattedData = {};

    specificationData?.forEach((entry) => {
      formattedData[entry.item] = entry.value;
    });

    fn({ productId, specifications: formattedData }).then(async (res) => {
      if (res?.data?.statusCode == 201) {
        // dispatch(setProductCurrentStep('STEP3'))
      }
    });
  };

  useEffect(() => {
    if (isSuccess) {
      const message = data?.message || 'Product created successfully';
      toast.success(message);
      // dispatch(setProductInfo({ ...getValues(), productId: data?.response }))

      if (!isExit) {
        dispatch(setProductCurrentStep('STEP3'));
      } else {
        navigate('/products-list');
      }
    }
    if (error) {
      if ('data' in error) {
        const errorData = error;
        toast.error(errorData.data.message);
      }
    }
  }, [data, isSuccess, error]);

  const testNrWatch = watch('testNr');

  const [showModal, setShowModal] = useState(false);
  const [deleteItem, setdeleteItem] = useState({});

  if (listLoading || globalLoading) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <Breadcrumb title='Create Product' pageTitle='Products' />
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Card>
          <Card.Header>
            <div className='d-flex'>
              <div className='flex-shrink-0 me-3'>
                <div className='avatar-sm'>
                  <div className='avatar-title rounded-circle bg-light text-primary fs-20'>
                    <i className='ri-file-info-line'></i>
                  </div>
                </div>
              </div>
              <div className='flex-grow-1 d-flex align-items-center justify-content-between'>
                <h5 className='card-title mb-1'>Product Specification</h5>
                <Button
                  variant='primary'
                  id='add-btn'
                  type='button'
                  onClick={() => addtestNr({ item: '', value: '' })}
                  className='py-1 px-2'
                >
                  Add More Specification
                </Button>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            {testNrWatch.map((st, index) => {
              return (
                <Row key={st?.item}>
                  <Col lg={4} className='mb-3'>
                    <Form.Label htmlFor='product-title-input'>Specification Type</Form.Label>
                    <RHSelectField
                      name={`testNr.${index}.item`}
                      onChange={async (e) => {
                        sftypeValue(e, index);
                      }}
                      list={listData?.response?.map((item, index) => {
                        return { name: item?.name, value: item?.name };
                      })}
                    />
                  </Col>
                  <Col lg={4} className='mb-3'>
                    <Form.Label htmlFor='product-title-input'>Specification Type</Form.Label>
                    <RHSelectField
                      name={`testNr.${index}.value`}
                      list={sftype[st?.item]?.map((it) => ({
                        name: it?.label,
                        value: it?.value,
                      }))}
                    />
                  </Col>

                  <Col lg={1} className='mb-3 my-auto'>
                    <div className='align-items-end d-flex gap-1 hstack justify-content-end'>
                      {/* <Button
                        variant='primary'
                        id='add-btn'
                        type='button'
                        onClick={() => addtestNr({ item: '', value: '' })}
                        className='py-1 px-2'
                      >
                        <i className='ri-add-box-line fs-22'></i>
                      </Button> */}
                      <Button
                        variant='primary'
                        id='add-btn'
                        type='button'
                        // disabled={testNrFields?.length === 1}
                        onClick={() => {
                          // setSftype((prev) => ({ ...prev, [`testNr${index}item`]: spData?.response?.value }));
                          setGlobalLoading(true);
                          // removetestNr(index);
                          setdeleteItem({ name: testNrWatch[index]?.item, index });
                          setShowModal(true);
                          setGlobalLoading(false);
                        }}
                        className='py-1 px-2'
                      >
                        <i className='ri-delete-bin-5-fill fs-22'></i>
                      </Button>
                    </div>
                  </Col>
                </Row>
              );
            })}
          </Card.Body>
        </Card>

        <Container fluid>
          <div className='d-flex'>
            <div>
              <button
                className='btn btn-primary shadow-lg rounded'
                onClick={() => {

                  navigate(`/product-edit/${productId}`)
                  dispatch(setProductCurrentStep('STEP1'));
                }}
              >
                Previous
              </button>
            </div>
            <div className='ms-auto'>
              <button
                className='btn btn-info shadow-lg rounded'
                type='submit'
                onClick={() => {
                  setIsExit(true);
                }}
              >
                Draft & Exit
              </button>
              <button
                className='btn  btn-danger shadow-lg rounded ms-2'
                onClick={() => navigate('/products-list')}
              >
                Cancel
              </button>

              <button className='btn btn-secondary shadow-lg rounded ms-2' type='submit'>
                Next
              </button>
            </div>
          </div>
        </Container>
      </FormProvider>

      <DeleteModal
        showModal={showModal}
        // loading={deleteLoading}
        setShowModal={setShowModal}
        data={deleteItem}
        handleSubmit={() => {
          const filtrItem = testNrWatch.filter((it) => it.item !== deleteItem?.name);
          setValue('testNr', filtrItem);
          setShowModal(false);
          // removetestNr(deleteItem?.index);
        }}
      />
    </>
  );
};

export default StepSpecification;
